import axios from "axios";
import React, { useEffect, useState } from "react";
import { apiCall_domain } from "../../api";
import Header from "../../header";
import Spinner from "../../Spinner/Spinner";
import { TabsComp } from "./TabsComp";
import { Link, useHistory } from "routerCompat";
import AddTicket from "../../vendor/AddTicket";
import { Rating } from "react-simple-star-rating";

const ServiceItemDetails = () => {
  const history = useHistory();

  let id = history.location.search.split("");
  id.splice(0, 1);
  id = id.join("");
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [comments, setComments] = useState();
  const [ticket, setTicket] = useState(false);

  const handleTicket = () => {
    setTicket(!ticket);
  };

  useEffect(() => {
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .post(
        `${apiCall_domain}/customer/mechanics/info`,
        { mechanic_id: id },
        {
          headers,
        },
      )
      .then((res) => {
        setData(res.data.data);
        axios
          .get(
            `https://xyz.kacharlife.com/api/v1/customer/mechanics/comments?garage_id=${id}`,
            {
              headers,
            },
          )
          .then((res) => {
            setComments(res.data.data);
            setLoading(false);
          });
      });
  }, []);

  return loading ? (
    <Spinner />
  ) : ticket ? (
    <AddTicket ticketHandler={handleTicket} garage_id={data.id} />
  ) : (
    <>
      <Header showSearchBar={true} title={`${data.name}`} />
      <div className="serviceItem">
        <div className="serviceItemImg">
          <div className="serviceName">
            <div className="serviceTitle">
              <h4>تعمیرگاه {data?.name} </h4>
              <Rating ratingValue={data.rate * 20} readonly={true} />
            </div>
            <span>{data?.city_name}</span>
          </div>
          <div className="serviceDetailSection">
            <div className="serviceDetail">
              <i className="icon-screwdriver-wrench" />
              <div>
                <span>نحوه خدمت رسانی : خدمات</span>
                <span>{data?.type === "static" ? "ثابت" : "سیار و ثابت"}</span>
              </div>
            </div>
            <div className="serviceDetail">
              <i className="icon-bag" />
              <div>
                <span>نوع خدمات:</span>
                <div>
                  {data?.parent_services.map((service, i) => (
                    <span>
                      {" "}
                      {i !== 0 ? "," : null} {service.title}{" "}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div className="serviceDetail">
              <i className="icon-wrench-cog1" />
              <div>
                <span>خدمات قابل ارایه:</span>
                <div>
                  {data?.services.map((service, i) => (
                    <span>
                      {" "}
                      {i !== 0 ? "," : null} {service.title}{" "}
                    </span>
                  ))}
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
        <Link
          className="reserveService"
          to={`/services/serviceItemDetails/reserve?${id}`}
        >
          رزرو سرویس
        </Link>
      </div>
      <TabsComp data={data} comments={comments} />
      <div className="serviceFooter">
        <div className="contactGarage" onClick={handleTicket}>
          پیام به گاراژ
        </div>
      </div>
    </>
  );
};

export default ServiceItemDetails;
